import React from 'react';
import NumberFormat from 'react-number-format';

export default function NewHome(props) {
	return (
		<div className="form-question py-2">
			<div className="form-content" >
				<h4 className="form-content-heading m-0">
					What is the maximum price you want to pay for a new home?
				</h4>
				<div className="pt-2 form-content-field">
					<div className="py-2">
						<div className="w-res-50">
							<div>
								<NumberFormat
									className="amount-field"
									thousandSeparator={','}
									decimalSeparator={'.'}
									autoComplete='off'
									prefix="$"
									allowNegative={false}
									decimalScale={2}
									maxLength="10"
									id="homeWorth"
									inputMode="numeric"
									name="new_home_purchase_price"
									value={props.values.new_home_purchase_price}
									onChange={props.handleChange}
									allowEmptyFormatting />
							</div>
						</div>
						{props.validateDisplay9 === true ?
							props.errors.new_home_purchase_price ?
								<div className="error-msg mt-3">{props.errors.new_home_purchase_price}</div> : ''
							: ''}
					</div>
				</div>
			</div>
		</div>
	)
}
